var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationDot = function SvgLocationDot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.5 10a4.501 4.501 0 0 0-9 0c0 .387.14.988.478 1.787.328.775.794 1.632 1.328 2.497.89 1.444 1.922 2.838 2.694 3.832.775-.994 1.806-2.388 2.694-3.832.534-.865 1-1.722 1.328-2.497.337-.8.478-1.4.478-1.787m1.5 0c0 2.731-3.656 7.594-5.26 9.6a.944.944 0 0 1-1.48 0C9.655 17.594 6 12.731 6 10c0-3.312 2.688-6 6-6 3.313 0 6 2.688 6 6m-5 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-3.5 0a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0"
  })));
};
export default SvgLocationDot;